import { createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withKeys as _withKeys, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-00ec98c1")

_pushScopeId("data-v-00ec98c1")
const _hoisted_1 = /*#__PURE__*/_createVNode("h1", null, "マンガフィールド管理者画面", -1)
const _hoisted_2 = { class: "form" }
const _hoisted_3 = /*#__PURE__*/_createVNode("label", null, "ユーザーID：", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("label", null, "パスワード：", -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("span", null, "ログイン", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")

  return (_openBlock(), _createBlock("div", {
    class: "login",
    onKeydown: _cache[4] || (_cache[4] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.signin && _ctx.signin(...args)), ["prevent"]), ["enter"]))
  }, [
    _hoisted_1,
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _withDirectives(_createVNode("input", {
        type: "text",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.email = $event))
      }, null, 512), [
        [_vModelText, _ctx.email]
      ]),
      _hoisted_4,
      _withDirectives(_createVNode("input", {
        type: "password",
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.password = $event))
      }, null, 512), [
        [_vModelText, _ctx.password]
      ]),
      _createVNode(_component_ErrorMessage, {
        messages: _ctx.errorMessages.LoginError
      }, null, 8, ["messages"]),
      _createVNode("button", {
        class: "primary-button colspan",
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.signin && _ctx.signin(...args)))
      }, [
        _hoisted_5
      ])
    ])
  ], 32))
})